import { toast } from "react-toastify";
import firebase from "../firebase";
import { customAlert } from "./alertActions";
import { GET_COLLABORATIVES_REQUESTS } from "./types";
export const getCollaborativesRequests = (id) => async (dispatch) => {
  firebase
    .firestore()
    .collection("memoir_requests")
    .where("memoir_creator", "==", id)
    .onSnapshot((query) => {
      var tempCollaboratives = [];
      query.forEach((doc) => {
        tempCollaboratives.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_COLLABORATIVES_REQUESTS,
        payload: tempCollaboratives,
      });
    });
};

export const getCollaborativesInvitation = (id) => async (dispatch) => {
  firebase
    .firestore()
    .collection("memoir_collab_invitations")
    .where("invited_by", "==", id)
    .where("status", "==", "pending")
    .onSnapshot((query) => {
      var tempCollaboratives = [];
      query.forEach((doc) => {
        tempCollaboratives.push({ id: doc.id, ...doc.data() });
      });
      console.log("run...", tempCollaboratives);
      dispatch({
        type: "GET_COLLAB_INVITATIONS",
        payload: tempCollaboratives,
      });
    });
};

export const getCollaborativesInvitationRequests = (id) => async (dispatch) => {
  firebase
    .firestore()
    .collection("memoir_collab_invitations")
    .where("invited_to", "==", id)
    .where("status", "==", "pending")
    .onSnapshot((query) => {
      var tempCollaboratives = [];
      query.forEach((doc) => {
        tempCollaboratives.push({ id: doc.id, ...doc.data() });
      });
      console.log("run...", tempCollaboratives);
      dispatch({
        type: "GET_COLLAB_INVITATIONS_REQUEST",
        payload: tempCollaboratives,
      });
    });
};

export const colllabLoading = (val) => async (dispatch) => {
  dispatch({
    type: "COLLAB_LOADING",
    payload: val,
  });
};
export const createCollabRequest = (obj) => async (dispatch) => {
  dispatch(colllabLoading(true));
  let docRef = await firebase
    .firestore()
    .collection("memoirs")
    .doc(obj.memoir_id)
    .get();
  let newObj = docRef
    .data()
    .collaborators.find((collab) => collab.id == obj.requestor_id);

  if (newObj == undefined) {
    let check = false;
    let invitationData = await firebase
      .firestore()
      .collection("memoir_requests")
      .where("memoir_id", "==", obj.memoir_id)
      .get();
    invitationData.docs.map((doc) => {
      if (doc.data().requestor_id == obj.requestor_id) {
        check = true;
      }
    });
    if (check) {
      dispatch(customAlert(true, "Already requested for this memoir!"));
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.warning('Already requested for this memoir!');
      dispatch(colllabLoading(false));
    } else {
      firebase
        .firestore()
        .collection("memoir_requests")
        .add({
          ...obj,
          created: firebase.firestore.Timestamp.now(),
        })
        .then(async (res) => {
          await firebase.firestore().collection("notifications").add({
            user_id: obj.requestor_id,
            notify_to: obj.memoir_creator,
            type: "collab",
            status: "requested",
            memoir_id: obj.memoir_id,
            created_at: firebase.firestore.Timestamp.now(),
          });
          dispatch(colllabLoading(false));
          dispatch(customAlert(true, "Your request has been submitted"));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          // toast.success('Your request has been submitted');
        })
        .catch((e) => {
          dispatch(colllabLoading(false));
          dispatch(customAlert(true, e.message));
          setTimeout(() => {
            dispatch(customAlert(false, ""));
          }, 3000);
          // toast.warning(e.message);
        });
    }
  } else {
    dispatch(customAlert(true, "Already a collaborator in this memoir!"));
    setTimeout(() => {
      dispatch(customAlert(false, ""));
    }, 3000);
    // toast.warning('Already a collaborator in this memoir!');
    dispatch(colllabLoading(false));
  }
};
export const getTimelineRequestUser = (uid) => async (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .doc(uid)
    .get()
    .then((res) => {
      dispatch({
        type: "MY_COLLAB_REQUESTS",
        payload: res.data(),
      });
    });
};
export const fetchByEmail = (email) => async (dispatch) => {
  firebase
    .firestore()
    .collection("users")
    .where("email", "==", email)
    .onSnapshot((query) => {
      var temp = [];
      query.forEach((doc) => {
        temp.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: "FETCH_BY_EMAIL",
        payload: temp,
      });
    });
};
export const acceptMemoirCollabRequest =
  (id, obj, req_id, memoir_creator) => async (dispatch) => {
    let docRef = await firebase.firestore().collection("memoirs").doc(id).get();
    let newObj = docRef
      .data()
      .collaborators.find((collab) => collab.id == obj.id);
    if (newObj == undefined) {
      firebase
        .firestore()
        .collection("memoirs")
        .doc(id)
        .update({
          collaborators: firebase.firestore.FieldValue.arrayUnion(obj),
        })
        .then(async (res) => {
          await firebase.firestore().collection("notifications").add({
            user_id: memoir_creator,
            type: "collab",
            status: "accepted",
            memoir_id: id,
            notify_to: obj.id,
            read: false,
            created_at: firebase.firestore.Timestamp.now(),
          });
          dispatch(removeMemoirCollabRequest(req_id));
        });
    } else {
      dispatch(
        customAlert(true, "Collaborator already present in this Memoir")
      );
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.warning('Collaborator already present in this Memoir');
    }
  };

export const acceptMemoirCollabInvitationRequest =
  (id, obj, req_id, notify_to) => async (dispatch) => {
    await firebase
      .firestore()
      .collection("memoir_collab_invitations")
      .doc(req_id)
      .update({ status: "accepted" })
      .then((res) => {
        firebase
          .firestore()
          .collection("memoirs")
          .doc(id)
          .update({
            collaborators: firebase.firestore.FieldValue.arrayUnion(obj),
          })
          .then(async (res) => {
            await firebase.firestore().collection("notifications").add({
              user_id: obj.id,
              type: "collab",
              status: "accepted",
              memoir_id: id,
              notify_to,
              read: false,
              created_at: firebase.firestore.Timestamp.now(),
            });
            await dispatch(removeMemoirCollabInvitation(req_id));
          })
          .catch((err) => {
            dispatch(customAlert(true, err.message));
            setTimeout(() => {
              dispatch(customAlert(false, ""));
            }, 3000);
          });
      })
      .catch((err) => {
        dispatch(customAlert(true, err.message));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
      });
  };

export const rejectMemoirCollabInvitationRequest =
  (req_id) => async (dispatch) => {
    await firebase
      .firestore()
      .collection("memoir_collab_invitations")
      .doc(req_id)
      .update({ status: "rejected" });
  };

export const removeMemoirCollabRequest = (req_id) => async (dispatch) => {
  firebase.firestore().collection("memoir_requests").doc(req_id).delete();
};

export const removeMemoirCollabInvitation = (req_id) => async (dispatch) => {
  console.log("req_id", req_id);
  firebase
    .firestore()
    .collection("memoir_collab_invitations")
    .doc(req_id)
    .update({ is_deleted: true });
  // .delete();
};

export const updateMemoirCollab = (id, obj, u_id) => async (dispatch) => {
  dispatch(colllabLoading(true));
  let docRef = await firebase.firestore().collection("memoirs").doc(id).get();
  let newObj = docRef
    .data()
    .collaborators.find((collab) => collab.id == obj.id);

  if (newObj == undefined) {
    let check = false;
    let invitationData = await firebase
      .firestore()
      .collection("memoir_collab_invitations")
      .where("memoir_id", "==", id)
      .get();
    invitationData.docs.map((doc) => {
      if (doc.data().invited_to == obj.id) {
        check = true;
      }
    });
    if (check) {
      dispatch(customAlert(true, "Member already invited in this memoir"));
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.warning('Member already invited in this memoir');
      dispatch(colllabLoading(false));
    } else {
      await firebase.firestore().collection("memoir_collab_invitations").add({
        invited_by: u_id,
        invited_to: obj.id,
        role: obj.role,
        memoir_id: id,
        invited_at: firebase.firestore.Timestamp.now(),
        status: "pending",
      });

      await firebase.firestore().collection("notifications").add({
        user_id: u_id,
        type: "collab",
        status: "invited",
        notify_to: obj.id,
        read: false,
        memoir_id: id,
        created_at: firebase.firestore.Timestamp.now(),
      });
      dispatch(customAlert(true, "Member Invited Successfully!"));
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.success('Member Invited Successfully!');
      dispatch(colllabLoading(false));
    }
  } else {
    dispatch(customAlert(true, "Collaborator already present in this Memoir"));
    setTimeout(() => {
      dispatch(customAlert(false, ""));
    }, 3000);
    // toast.warning('Collaborator already present in this Memoir');
    dispatch(colllabLoading(false));
  }
};
export const updateMemoirCollabForNonUser =
  (id, obj, u_id) => async (dispatch) => {
    dispatch(colllabLoading(true));
    let docRef = await firebase.firestore().collection("memoirs").doc(id).get();
    let newObj = docRef
      .data()
      .collaborators.find((collab) => collab.id == obj.id);

    if (newObj == undefined) {
      let check = false;
      let invitationData = await firebase
        .firestore()
        .collection("memoir_collab_invitations")
        .where("memoir_id", "==", id)
        .get();
      invitationData.docs.map((doc) => {
        if (doc.data().invited_to == obj.id) {
          check = true;
        }
      });
      if (check) {
        dispatch(customAlert(true, "Member already invited in this memoir"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // toast.warning('Member already invited in this memoir');
        dispatch(colllabLoading(false));
      } else {
        await firebase.firestore().collection("memoir_collab_invitations").add({
          invited_by: u_id,
          invited_to: obj.id,
          role: obj.role,
          memoir_id: id,
          invited_at: firebase.firestore.Timestamp.now(),
          status: "pending",
        });

        await firebase.firestore().collection("notifications").add({
          user_id: u_id,
          type: "collab",
          status: "invited",
          notify_to: obj.id,
          read: false,
          memoir_id: id,
          created_at: firebase.firestore.Timestamp.now(),
        });
        await firebase
          .firestore()
          .collection("users")
          .doc(obj.id)
          .set({ email: obj.email });
        dispatch(customAlert(true, "Member Invited Successfully!"));
        setTimeout(() => {
          dispatch(customAlert(false, ""));
        }, 3000);
        // toast.success('Member Invited Successfully!');
        dispatch(colllabLoading(false));
      }
    } else {
      dispatch(
        customAlert(true, "Collaborator already present in this Memoir")
      );
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.warning('Collaborator already present in this Memoir');
      dispatch(colllabLoading(false));
    }
  };
export const removeMemoirCollab = (memoirId, obj) => async (dispatch) => {
  // console.log('memoirs', memoirId, 'coo', obj)
  firebase
    .firestore()
    .collection("memoirs")
    .doc(memoirId)
    .update({
      collaborators: firebase.firestore.FieldValue.arrayRemove(obj),
    })
    .then((res) => {
      dispatch(customAlert(true, "Collaborator Removed Successfully"));
      setTimeout(() => {
        dispatch(customAlert(false, ""));
      }, 3000);
      // toast.success('Collaborator Removed Successfully');
    });
};
